<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :customClass="'customer-create create-form'"
    v-if="getPermission('lead:create')"
  >
    <template v-slot:header-title>
      <h1 class="form-title d-flex">
        Create a new Lead
        <SystemGenerateId
          v-if="barcode"
          :system-id="barcode"
        ></SystemGenerateId>
      </h1>
    </template>
    <template v-slot:header-action>
      <v-btn
        v-on:click="goBack"
        :disabled="formLoading"
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>

      <v-btn
        :disabled="!formValid || formLoading || contactPersons.length === 0"
        :loading="formLoading"
        depressed
        class="mx-2 custom-bold-button white--text"
        v-on:click="onSubmit"
        color="cyan"
      >
        Save Lead
      </v-btn>
    </template>
    <template v-slot:body>
      <v-form
        ref="leadForm"
        v-model.trim="formValid"
        lazy-validation
        v-on:submit.stop.prevent="onSubmit"
      >
        <v-tabs
          v-model="leadTab"
          background-color="transparent"
          centered
          color="cyan"
          fixed-tabs
          grow
          class="custom-tab-transparent"
          hide-slider
        >
          <template v-for="(tab, index) in tabs">
            <v-tab
              class="font-size-16 font-weight-600 px-8"
              v-if="getPermission(tab.permission + ':create')"
              :key="index"
              :disabled="steps[tab.key]"
              :href="'#tab-' + tab.key"
            >
              <v-icon color="grey darken-4" left>{{ tab.icon }}</v-icon>
              {{ tab.title }}
            </v-tab>
          </template>
        </v-tabs>
        <v-tabs-items v-model="leadTab">
          <v-tab-item :value="'tab-details'">
            <BasicDetails
              :detail="basicInfo"
              @update:detail="(val) => Object.assign(basicInfo, val)"
            ></BasicDetails>
          </v-tab-item>
          <v-tab-item :value="'tab-contact-person'">
            <ContactPersons
              v-on:saveContactPerson="updateContactPerson"
            ></ContactPersons>
          </v-tab-item>
        </v-tabs-items>
      </v-form>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import { mapGetters } from "vuex";
import CommonMixin from "@/core/plugins/common-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { POST, CLEAR_ERROR, GET } from "@/core/services/store/request.module";
import SystemGenerateId from "@/view/pages/partials/SystemGenerateId.vue";
import BasicDetails from "@/view/pages/lead-new/create-or-update/Basic-Details.vue";
import ContactPersons from "@/view/pages/lead-new/create-or-update/Contact-Persons.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";

export default {
  mixins: [CommonMixin],
  name: "lead-create",
  title: "Create Lead",
  data() {
    return {
      leadId: 0,
      lead: {},
      propertyAddress: {},
      barcode: null,
      basicDetail: {},
      contactDetail: {},
      contactPersons: [],
      notification: {},
      basicInfo: {
        id: null,
        status: null,
        source: null,
        opportunity: null,
        product_type: null,
        assign_to: null,
        amount: null,
        lead_name: null,
        company_name: null,
        lead_date: null,
        position: null,
        postal_code: null,
        email: null,
        address_line_1: null,
        address_line_2: null,
        unit_no: null,
        zip: null,
        country: null,
        expected_close_date: null,
        actual_closed_date: null,
        phone_number: null,
        website: null,
        internal_remark: null,
        email_reply: null,
        is_public: 0,
        contacted_today: 1,
        isLeadCreated: false,
        attachments: [],
      },
      tabs: [
        {
          title: "Lead Information",
          icon: "mdi-phone",
          key: "details",
          permission: "lead",
        },

        {
          title: "Contact Persons",
          icon: "mdi-account-multiple",
          key: "contact-person",
          permission: "lead",
        },
      ],
      leadTab: "tab-details",
      options: {},
      steps: {
        details: false,
        "contact-person": true,
        "extra-info": true,
        attachment: true,
      },
    };
  },
  components: {
    BasicDetails,
    ContactPersons,
    CreateUpdateTemplate,
    SystemGenerateId,
  },
  watch: {
    leadTab() {
      const _this = this;
      setTimeout(function () {
        _this.$refs.leadForm.validate();
        _this.$nextTick(() => {
          _this.activateTab();
        });
      }, 200);
    },
    formValid(param) {
      if (param) {
        this.activateTab();
        this.$store.dispatch(CLEAR_ERROR, {});
      }
    },
  },
  methods: {
    activateTab() {
      if (this.formValid) {
        if (this.leadTab == "tab-details") {
          this.steps["contact-person"] = false;
        }
      }
    },

    updateContactPerson(param) {
      this.contactPersons = param;
    },

    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "customer/options" })
        .then(({ data }) => {
          _this.options = data.options;
          _this.barcode = data.barcode;
          _this.options.allow_zones = data.allow_zones;
          _this.options.active_zones = data.active_zones;
          _this.options.all_tags = data.all_tags;
          _this.options.all_cms_categories = data.all_cms_categories;
        })
        .catch((error) => {
          _this.logError(error);
        });
      /*.finally(() => {
          _this.$refs.leadForm.validate();
        });*/
    },

    async onSubmit() {
      const _this = this;

      try {
        const formErrors = _this.validateForm(_this.$refs.leadForm);
        if (formErrors && formErrors.length) {
          for (let i = 0; i < formErrors.length; i++) {
            ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          }
          return false;
        }

        if (!_this.$refs.leadForm.validate()) {
          return false;
        }

        _this.$store.dispatch(CLEAR_ERROR, {});

        const formData = {
          id: _this.basicInfo?.id || null,
          status: _this.basicInfo?.status || null,
          source: _this.basicInfo?.source || null,
          opportunity: _this.basicInfo?.opportunity || null,
          product_type: _this.basicInfo?.product_type || null,
          assign_to: _this.basicInfo?.assign_to || null,
          amount: _this.basicInfo?.amount || null,
          lead_name: _this.basicInfo?.lead_name || null,
          company_name: _this.basicInfo?.company_name || null,
          lead_date: _this.basicInfo?.lead_date || null,
          position: _this.basicInfo?.position || null,
          postal_code: _this.basicInfo?.postal_code || null,
          email: _this.basicInfo?.email || null,
          address_line_1: _this.basicInfo?.address_line_1 || null,
          address_line_2: _this.basicInfo?.address_line_2 || null,
          unit_no: _this.basicInfo?.unit_no || null,
          country: _this.basicInfo?.country || null,
          expected_close_date: _this.basicInfo?.expected_close_date || null,
          actual_closed_date: _this.basicInfo?.actual_closed_date || null,
          entity_id: _this.basicInfo?.entity_id || null,
          phone_number: _this.basicInfo?.phone_number || null,
          website: _this.basicInfo?.website || null,
          internal_remark: _this.basicInfo?.internal_remark || null,
          email_reply: _this.basicInfo?.email_reply || null,
          is_public: _this.basicInfo?.is_public || 0,
          contacted_today: _this.basicInfo?.contacted_today || 0,
          persons: _this.contactPersons || [],
          attachments: _this.basicInfo?.attachments || [],
        };

        _this.formLoading = true;
        try {
          if (!_this.isLeadCreated) {
            let leadObject = await _this.$store.dispatch(POST, {
              url: "lead",
              data: formData,
            });
            _this.leadId = leadObject.data.id;
            _this.isLeadCreated = true;
          }
        } catch (error) {
          _this.formLoading = false;
          ErrorEventBus.$emit(
            "update:error",
            "Lead is not created. Please try again."
          );
          return false;
        }

        if (_this.isLeadCreated) {
          _this.$router.push(
            _this.getDefaultRoute("lead.detail", {
              params: { id: _this.leadId },
            })
          );
        }
      } catch (error) {
        ErrorEventBus.$emit("update:error", InitializeError(error));
        _this.formLoading = false;
        return false;
      }
    },

    getLead() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "leads/" + _this.leadId,
        })
        .then(({ data }) => {
          _this.lead = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
  },
  computed: {
    ...mapGetters(["gCreateFormFields"]),
  },
  mounted() {
    this.getOptions();

    this.$refs.leadForm.validate();

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Lead", route: "lead" },
      { title: "Create" },
    ]);

    this.leadId = this.lodash.toSafeInteger(this.$route.query.lead);
    if (this.leadId > 0) {
      this.getLead();
    }
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.isLeadCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>
<style scoped>
/* tabs css  */

.custom-tab-transparent.v-tabs--fixed-tabs > .v-tabs-bar .v-tab.v-tab--active {
  background-color: #00bcd4 !important;
  color: #fff !important;
  overflow: hidden;
}
.custom-tab-transparent.v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tab.v-tab--active
  .grey--text.text--darken-4 {
  color: #fff !important;
  caret-color: #fff !important;
}

.custom-tab-transparent.v-tabs .v-tab {
  background: #00bcd429;
  width: 25%;
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}

.custom-tab-transparent.v-tabs .v-tab:first-child {
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 0px) 50%
  );
}

.custom-tab-transparent.v-tabs .v-tab.v-tab:last-child {
  clip-path: polygon(
    0% 0%,
    calc(100% + -0px) 0%,
    100% 100%,
    calc(100% - 40px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}
</style>
